var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.Url,"width":"100%","height":"800px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }